// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","logo":"Footer_logo__+JiYo","footer-credits":"Footer_footer-credits__4HIS-","test":"Footer_test__+CXUy"};